module.exports = __webpack_public_path__ + "img/un-authed.de4ff130.png";